/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
// @mui material components
import { Dialog, DialogActions, DialogTitle, Icon, IconButton } from "@mui/material";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

// Material Dashboard 2 React components
import MDTypography from "components/MDTypography";
import { useMaterialUIController, setSuccessSB, setErrorSB } from "context";
import useLocale from "context/useLocale";
import { useState, useEffect } from "react";
import Moment from "react-moment";
import { Link, useParams } from "react-router-dom";

import { fetchAll, deleteById } from "services/VehicleModels";

export default function data() {
  const locale = useLocale();
  const [controller, dispatch] = useMaterialUIController();
  const { direction } = controller;
  const [rows, setRows] = useState([]);
  const [paginationMeta, setPaginationMeta] = useState({});
  const [open, setOpen] = useState([]);
  const [searchParams, setSearchParams] = useState({ brand: "", title: "" });
  const [sortBy, setSortBy] = useState("updated_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const { typeId } = useParams();

  const handleSearchChange = (key) => (e) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      [key]: e.target.value,
    }));
  };

  const handleSortChange = (sortColumn) => {
    let newSortOrder = "asc";
    if (sortBy === sortColumn && sortOrder === "asc") {
      newSortOrder = "desc";
    }
    setSortBy(sortColumn);
    setSortOrder(newSortOrder);
  };

  const handleClickOpen = (id) => {
    const openCopy = [...open];
    openCopy[id] = true;
    setOpen(openCopy);
  };

  const handleClose = (id) => {
    const openCopy = [...open];
    openCopy[id] = false;
    setOpen(openCopy);
  };

  const loadData = (page) => {
    fetchAll(
      {
        vehicle_type_id: typeId,
      },
      page,
      searchParams,
      sortBy,
      sortOrder
    ).then(
      (res) => {
        setRows(res.data.data.data);
        setPaginationMeta(res.data.data.meta.pagination);
      },
      (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)(err)
    );
  };

  useEffect(() => {
    loadData(1);
  }, [typeId, searchParams, sortBy, sortOrder]);

  const handleDelete = (id) => {
    deleteById(id).then(
      (res) => {
        loadData();
        setSuccessSB(dispatch, `${res.data.data.title.en} model has been removed`);
      },
      (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)
    );
    handleClose(id);
  };

  const renderRows = rows.map((row) => ({
    id: row.id,
    brand: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.brand.title[direction === "ltr" ? "en" : "ar"]}
      </MDTypography>
    ),
    title: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.title[direction === "ltr" ? "en" : "ar"]}
      </MDTypography>
    ),
    mainImage: (
      <MDAvatar
        src={`${process.env.REACT_APP_STORAGE_PREFIX}/${row.main_image}`}
        alt={row.title[direction === "ltr" ? "en" : "ar"]}
        size="lg"
        variant="square"
      />
    ),
    created_at: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        <Moment format="DD-MMM-YYYY, hh:mm A">{row.created_at}</Moment>
      </MDTypography>
    ),
    updated_at: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        <Moment format="DD-MMM-YYYY, hh:mm A">{row.updated_at}</Moment>
      </MDTypography>
    ),
    action: (
      <>
        <IconButton aria-label="edit" color="blue" component={Link} to={`edit/${row.id}`}>
          <Icon fontSize="sm">edit</Icon>
        </IconButton>
        <IconButton aria-label="delete" color="primary" onClick={() => handleClickOpen(row.id)}>
          <Icon fontSize="sm">delete</Icon>
        </IconButton>
        <Dialog
          open={typeof open[row.id] !== "undefined" && open[row.id]}
          onClose={() => handleClose(row.id)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Are you sure you want to delete model (${
              row.title[direction === "ltr" ? "en" : "ar"]
            }) ?`}
          </DialogTitle>
          <DialogActions>
            <MDButton variant="contained" onClick={() => handleClose(row.id)}>
              {locale("cancel")}
            </MDButton>
            <MDButton variant="contained" color="error" onClick={() => handleDelete(row.id)}>
              {locale("confirm")}
            </MDButton>
          </DialogActions>
        </Dialog>
      </>
    ),
  }));

  return {
    columns: [
      { Header: locale("id"), accessor: "id" },
      { Header: locale("brand"), accessor: "brand", searchable: "true" },
      { Header: locale("title"), accessor: "title", searchable: "true" },
      { Header: locale("mainImage"), accessor: "mainImage" },
      { Header: locale("createdAt"), accessor: "created_at" },
      { Header: locale("updatedAt"), accessor: "updated_at" },
      { Header: "Actions", accessor: "action", align: "left" },
    ],
    rows: renderRows,
    paginationMeta,
    loadData,
    handleSearchChange,
    handleSortChange,
  };
}
